export const DEFAULT_USER_ID = "000000000000000000000000000000000000";

export const getErrorPageDigitalData = () => {
  return {
    pageInfo: {
      destinationURL: location.href,
      language: "en",
      pageVersion: "Error_Page",
      pageTitle: document.title,
      version: "Global",
    },
    contentInfo: {
      contentGroup: "Error_Page",
    },
  };
};
